import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    padding: `${theme.spacing(5)}px ${theme.spacing(5)}px`,
    backgroundColor: '#FCF9F8',
    height: '100%'
  },
  paper: {
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    padding: `${theme.spacing(9)}px ${theme.spacing(12)}px`
  },
  formHeader: {
    fontWeight: 'normal'
  },
  form: {
    width: '65%'
  },
  inputBlock: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2)
  },
  inputRow: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    height: 70,
    marginBottom: theme.spacing(5)
  },
  emailRow: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2)
  },
  input: {
    height: '50px',
    width: '330px',
    '& input': {
      padding: '15px',
      color: '#000000',
      fontFamily: 'Tiempos Text',
      fontSize: '16px',
      letterSpacing: 0,
      lineHeight: '28px'
    },
    '& input::placeholder': {
      color: '#8688A1'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: '1px solid #C4C4D1',
        borderRadius: '2px'
      },
      '&:hover fieldset': {
        border: '1px solid #000000'
      },
      '&.Mui-focused fieldset': {
        border: '1px solid #000000'
      }
    }
  },
  label: {
    color: '#8688A1',
    marginBottom: '5px'
  },
  email: {
    color: '#000000',
    marginBottom: '5px',
    fontWeight: 'normal'
  },
  labelPlaceHolder: {
    height: '13px',
    marginBottom: '5px'
  },
  saveButton: {
    outline: 'none',
    color: '#FFFFFF',
    borderColor: 'transparent',
    borderRadius: '3px',
    height: '50px',
    backgroundColor: '#000000',
    padding: '18px 70px',
    cursor: 'pointer',
    '&:disabled': {
      cursor: 'default',
      backgroundColor: '#F2F4F9',
      color: '#C4C4D1'
    },
    '&:hover': {
      backgroundColor: '#000000',
      color: '#FFFFFF'
    },
    width: '125px'
  },
  loader: {
    height: '50px'
  },
  buttonBlock: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(6)
  },
  errorLabel: {
    color: 'red',
    textAlign: 'left',
    marginTop: '-25px'
  }
}))
